import styles from '@components/components/ContactCards/ContactCards.module.scss';
import React from 'react';
import {
  Button,
  Card,
  CardAction,
  CardBody,
  FontAwesomeProIcon,
  Heading,
  Image,
  Link,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const ContactCards = ({ headingLevel = 3, link, topics }) => (
  <ul className={styles.container}>
    {topics?.map(({ icon, id, name }) => (
      <li key={`contactCards-${id}`}>
        <Card
          as={Link}
          hasAction
          to={`${link?.url}?thema=${encodeURIComponent(name)}`}
        >
          <CardBody className={styles.cardBody}>
            <Image
              alt={icon?.alt}
              className={styles.cardIcon}
              src={icon?.src}
              srcSet={icon?.srcSet}
            />
            <Heading
              as={getHeadingTag(headingLevel)}
              className={styles.cardTitle}
              size="h6"
            >
              {name}
            </Heading>
            <CardAction>
              <Button aria-hidden shape="bubble" tabIndex={-1}>
                <FontAwesomeProIcon icon="chevron-right" />
              </Button>
            </CardAction>
          </CardBody>
        </Card>
      </li>
    ))}
  </ul>
);

ContactCards.propTypes = {
  headingLevel: PropTypes.number,
  link: PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        alt: PropTypes.string,
        src: PropTypes.string,
        srcSet: PropTypes.string,
      }),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ContactCards;
